import getFormNames from "../../../common/getFormNames";

const formNamesList = ["durationMinutes"] as const;

export const formNames = getFormNames({ formNamesList });
